module.exports = __webpack_public_path__ + "img/Group-224.4311bd57.svg";